export enum FAQType {
  Account = "Account",
  Wallet = "Wallet",
  Lucky7 = "Lucky 7",
  FourD = "4D",
  ScratchWin = "Scratch & Win",
  All = "All",
}
